import { QuestEditorApi } from "@worldwidewebb/client-quests";
import { axiosInstance, buildQuestClientBasePath } from "..";

const questEditorApi = new QuestEditorApi(undefined, buildQuestClientBasePath(), axiosInstance);

export async function getTranslatedSpeakerPassages() {
  try {
    const { data } = await questEditorApi.getTranslatedSpeakerPassages();

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
